import React, {Component} from 'react';
import {connect} from 'react-redux';
import UsersActions from '../../redux/UsersRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import PageWithTable from '../../components/PageWithTable';
import Lozenge from '@atlaskit/lozenge';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';

const columns = t => ([
  {
    key: 'fullName',
    dataKey: 'fullName',
    title: t('Full name'),
    sortable: true,
    minWidth: 320,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'userRole.name',
    dataKey: 'userRole.name',
    title: t("User's role"),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'dealer.name',
    dataKey: 'dealer.name',
    title: t('Company'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'dealer.city.region.name',
    dataKey: 'dealer.city.region.name',
    title: t('Region'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'isActive',
    dataKey: 'isActive',
    title: t('Status'),
    sortable: true,
    width: 140,
    cellRenderer: ({cellData}) =>
      cellData ?
        <Lozenge appearance='success'>{t('active')}</Lozenge>
        : <Lozenge appearance='default'>{t('blocked')}</Lozenge>,
  },
]);

class UsersPage extends Component {
  render() {
    const {
      users,
      fetching,
      totalPages,
      getUsers,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions.users) {
      return <Forbidden />;
    }

    return (
      <PageWithTable
        actionButton={{
          title: t('Add user'),
          href: '/users/new',
        }}
        filters={[
          {
            keyName: 'userRoleIds',
            placeholder: t('By roles'),
            data: dictionaries.userRoles.data,
            fetching: dictionaries.userRoles.fetching,
            getData: getDictionaries('userRoles'),
          },
          {
            keyName: 'companyIds',
            placeholder: t('By companies'),
            data: dictionaries.companies.data,
            fetching: dictionaries.companies.fetching,
            getData: getDictionaries('companies'),
          }
        ]}
        dataColumns={columns(t)}
        data={users}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={getUsers}
        {...this.props}
        permissions={permissions.user}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    users: state.users.data,
    totalPages: state.users.totalPages,
    fetching: state.users.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUsers: params => dispatch(UsersActions.usersRequest(params)),
    getDictionaries: (name, query) => () => dispatch(DictionariesActions.dictionariesRequest(name, query)),
  };
};

export default withTranslation('users', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsersPage));
